import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import queryString from 'query-string';
import { GetUnloadedFuelDataRequest, UnloadedFuelDataRecord, UpdateUnloadedFuelDataResolvedRequest } from '../types';

@Injectable({
    providedIn: 'root'
})
export class UnloadedFuelDataService {

    constructor(private http: HttpClient) { }

    get(request: GetUnloadedFuelDataRequest): Observable<UnloadedFuelDataRecord[]> {
        return this.http.get<UnloadedFuelDataRecord[]>(`/api/data-errors/unloadedfueldata?${queryString.stringify(request)}`)
            .pipe(tap(data => data.forEach(x => x.resolvedOriginalValue = x.resolved)));
    }

    updateDataResolved(request: UpdateUnloadedFuelDataResolvedRequest): Observable<void> {
        return this.http.patch<void>(`/api/data-errors/unloadedfueldata/resolved`, request);
    }
}